import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';
import { Button, ButtonAppearance, Text } from '@atlassian/learning-components';
import { Flex } from '@atlaskit/primitives/compiled';
import { css } from '@compiled/react';
import WarningIcon from '@atlaskit/icon/core/warning';

import { ClassTimeSlot } from './ClassTimeSlot';
import { FindOtherClasses } from './FindOtherClasses';

export type Session = {
  id: string;
  month: string;
  day: string;
  label: string;
  time: string;
};

interface Props extends Session {
  courseName: string;
  isFree?: boolean;
  hasConflict: boolean;
}

export const LowerSection = ({ month, day, label, time, courseName, isFree, hasConflict }: Props) => {
  const onEnrollForFreeClick = () => {};
  const onEnrollPartnerClick = () => {};

  const onEnrollClick = isFree ? onEnrollForFreeClick : onEnrollPartnerClick;
  const buttonLabel = isFree ? 'Enroll for free' : 'Enroll on a partner site';

  return (
    <div css={lowerSectionContainerStyles}>
      <div css={slotActionsContainerStyles}>
        <ClassTimeSlot iconMonth={month} iconDay={day} titleDate={label} subtitleTime={time} />
        <div css={buttonContainerStyles}>
          <FindOtherClasses courseName={courseName} />
          <Button label={buttonLabel} appearance={ButtonAppearance.PRIMARY} onClick={onEnrollClick} />
        </div>
      </div>
      {hasConflict && (
        <Flex alignItems="center" gap="space.050">
          <WarningIcon label="warning" color={token('color.icon.warning')} />
          <Text>You’re enrolled in another class that conflicts with this time</Text>
        </Flex>
      )}
    </div>
  );
};

const slotActionsContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: token('space.400'),

  [media.above.sm]: {
    flexDirection: 'row',
    gap: token('space.400'),
  },
});

const buttonContainerStyles = css({
  display: 'flex',
  flexDirection: 'row',
  gap: token('space.200'),
  alignItems: 'center',
});

const lowerSectionContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.400'),

  [media.above.sm]: {
    gap: token('space.200'),
  },
});
